import { useCallback, useEffect, useRef, useState } from 'react';

/**
 * Хук для использования поповеров.
 * @param {boolean} initialState Изначальное состояние.
 * @returns {{popover: object, isPopoverOpen: boolean, setPopoverOpen: function }} Объект содержащий референс поповера, состояние и функцию для его обновления.
 */
const usePopover = (initialState = false) => {
	const popover = useRef();
	const [isPopoverOpen, setPopoverOpen] = useState(initialState);

	const handleClickOutside = useCallback(
		(event) => {
			if (
				popover.current &&
				!popover.current.contains(event.target) &&
				isPopoverOpen
			) {
				setPopoverOpen(false);
			}
		},
		[popover, isPopoverOpen],
	);

	useEffect(() => {
		document.addEventListener('click', handleClickOutside);

		return () => {
			document.removeEventListener('click', handleClickOutside);
		};
	});

	return {
		popover,
		isPopoverOpen,
		setPopoverOpen,
	};
};

export default usePopover;
